/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { InputNumber, Slider } from "antd";
import i18next from 'i18next';

const RiskSelector = ({ t, filter, onChangeValue }) => {
  const [config, setConfig] = useState([
    1,
    5,
  ]);
  const [classN, setClassN] = useState('first');

  const onChange = (value) => {
    setConfig(value);
  }

  useEffect(() => {
    if (config) {
      onChangeValue(config);
      if (config[0] === 1 && config[1] === 5) {
        setClassN('first');
      } else if (parseInt(config[0]) === 1 && parseInt(config[1]) === 4) {
        setClassN('second');
      } else if (parseInt(config[0]) === 1 && parseInt(config[1]) === 3) {
        setClassN('third');
      } else if (parseInt(config[0]) === 1 && parseInt(config[1]) === 2) {
        setClassN('fourth');
      } else if (parseInt(config[0]) === 2 && parseInt(config[1]) === 5) {
        setClassN('fifth');
      } else if (parseInt(config[0]) === 2 && parseInt(config[1]) === 4) {
        setClassN('sixth');
      } else if (parseInt(config[0]) === 2 && parseInt(config[1]) === 3) {
        setClassN('seventh');
      } else if (parseInt(config[0]) === 3 && parseInt(config[1]) === 5) {
        setClassN('eigth');
      } else if (parseInt(config[0]) === 3 && parseInt(config[1]) === 4) {
        setClassN('ninth');
      } else if (parseInt(config[0]) === 4 && parseInt(config[1]) === 5) {
        setClassN('tenth');
      }
    }
  }, [config]);

  return (
    <div className={`risk-selector ${classN}`}>
      <label>{t(filter.label || '')}</label>
      <div className="risk-range">
        <div className="range-container">
          <label>{i18next.t('Dashboard::From')}</label>
          <InputNumber
            className="input-number"
            value={config[0]}
            min={1}
            max={config[1] - 0.1}
            step={0.1}
            onChange={(val) => val && setConfig((prev) => [val, prev[1]])}
          />
        </div>
        <div className="range-container">
          <label>{i18next.t('Dashboard::To')}</label>
          <InputNumber
            className="input-number"
            value={config[1]}
            min={config[0] + 0.1}
            max={5.0}
            step={0.1}
            onChange={(val) => {
              if (val) {
                setConfig((prev) => [prev[0], val]);
              }
            }}
          />
        </div>
      </div>
      <Slider
        onChange={onChange}
        range
        value={config}
        step={0.1}
        max={5}
        min={1}
      />
    </div>
  );
};

export default RiskSelector;
